import { Component } from "react";
import PropTypes from "prop-types";
import global from "global";
import withDismissible from "../WithDismissible";

const withTouchOutsideDismissible = ({
  component: WrappedComponent,
  className,
  shouldRenderKey
}) => {
  class WithTouchOutsideDismissible extends Component {
    constructor(props) {
      super(props);
    }

    componentDidMount() {
      global.document.addEventListener("mousedown", this.handleOutside);
      global.document.addEventListener("keydown", this.handleKeydownOutside);
      global.document.addEventListener("touchstart", this.handleTouchOutside);
    }

    componentWillUnmount() {
      global.document.removeEventListener("mousedown", this.handleOutside);
      global.document.removeEventListener("keydown", this.handleKeydownOutside);
      global.document.removeEventListener(
        "touchstart",
        this.handleTouchOutside
      );
    }

    setWrapperRef = node => {
      this.wrapperRef = node;
    };

    handleOutside = ({ target }) => {
      if (this.wrapperRef && !this.wrapperRef.contains(target)) {
        this.props.onDismiss();
      }
    };

    handleKeydownOutside = ({ keyCode, target }) => {
      if (keyCode === 13 || keyCode === 27) {
        this.handleOutside({ target });
      }
    };

    handleTouchOutside = ({ targetTouches: [{ target }] }) => {
      this.handleOutside({ target });
    };

    render() {
      const { [shouldRenderKey]: shouldRender } = this.props;

      if (!shouldRender) return null;

      const DimissibleWrappedComponent = withDismissible({
        component: WrappedComponent,
        className,
        shouldRenderKey
      });

      return (
        <div ref={this.setWrapperRef}>
          <DimissibleWrappedComponent {...this.props} />
        </div>
      );
    }
  }

  WithTouchOutsideDismissible.propTypes = {
    onDismiss: PropTypes.func.isRequired
  };

  return WithTouchOutsideDismissible;
};

export default withTouchOutsideDismissible;
